import { S3Client, GetObjectCommand } from '@aws-sdk/client-s3';

// @ts-ignore
export const s3Client = new S3Client({
  region: 'ap-southeast-2',
  credentials: {
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  },
});

export const streamToString = (stream: any): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = stream.getReader();
    const decoder = new TextDecoder();
    let result = '';

    reader
      .read()
      .then(function processText({ done, value }: { done: any; value: any }) {
        if (done) {
          resolve(result);
          return;
        }
        result += decoder.decode(value, { stream: true });
        return reader.read().then(processText);
      })
      .catch(reject);
  });
};

export const BUCKET_NAME = 'news-crawler-st';

export async function fetchS3Json<T>(key: string): Promise<T> {
  const command = new GetObjectCommand({
    Bucket: BUCKET_NAME,
    Key: key,
  });
  const response = await s3Client.send(command);
  const bodyContents = await streamToString(response.Body);
  return JSON.parse(bodyContents) as T;
}
